module.exports = __webpack_public_path__ + "img/logo_telessaude.7f7ff3b4.svg";